<template>
  <div class="bg-secondary px-10 rounded">
    <!-- START ADD ATTENDEE MODAL -->
    <add-attendee-modal
    v-if="renderAddAttendeeModal"
    :capacity="reserveMeetingDevice.capacity"
    :need_room="need_room"
    :reserveMeetingCompanyId="reserveMeetingCompany.id"
    :deviceId="deviceId"
    :startTime="`${this.startDate} ${this.startHours}:${this.startMinutes}:00`"
    :endTime="`${this.endDate} ${this.endHours}:${this.endMinutes}:00`"
    :calendar="calendar"
    :previewEvent="previewEvent"
    :roomReservations="changeEvents"
    @setAllMembers="setAllMembers"
    @setAttendeesArray="setAttendeesArray"
    @setGuests="setGuests"
    :isMoreThanCapacity="isMoreThanCapacity"
    :initialMembers="initialMembers"
    :initialGuests="initialGuests" />
    <!-- END ADD ATTENDEE MODAL -->
    <div v-scroll-lock="activeModal === 'addAttendee'">
      <!-- Start TimeLine Bar -->
      <div class="edit-meeting-container flex justify-between" v-if="meetingInfo">
        <!-- Start Calendar  -->
        <div class="w-500 full-width reserve-width">
          <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-x-20 relative">
            <input
              type="text"
              class="meeting-name"
              v-model="reserveMeeting.meeting_name"
              :placeholder="$t('meeting_name')"
            />
            <textarea
              class="meeting-description"
              :placeholder="$t('description')"
              v-model="reserveMeeting.meeting_description"
              ref="textarea"
              rows="1"
            >
            </textarea>
            <div class="flex gap-15 border border-b-0 border-default">
              <base-multi-choice
                height="50"
                :options="userInformation.companies"
                :placeholder="$t('company')"
                :default="defaultCompany"
                v-model="reserveMeetingCompany"
                @input="selectCompanyHandler"
                radius="sm"
                shouldExpand
                hasNameAvatar
              />
              <base-multi-choice
                height="50"
                :options="deviceOptions"
                :placeholder="$t('room')"
                :default="defaultDevice"
                v-model="reserveMeetingDevice"
                @input="selectDeviceHandler"
                radius="sm"
                :disabled="!need_room"
                shouldExpand
                hasIcon
              />
            </div>
            <div class="rounded-b-sm border border-default h-50 grid grid-rows-1 grid-cols-2">
              <label class="cursor-pointer">
                <input
                  type="checkbox"
                  id="save_default"
                  class="check-box-classes hidden"
                  v-model="need_room"
                />
                <div
                  class="flex items-center justify-center gap-x-10 h-50"
                  :class="need_room ? 'bg-primaryOpacity font-bold' : ''"
                >
                  <room :color="need_room ? 'var(--color-primary)' : 'var(--color-icon)'" />
                  <span :class="need_room ? 'text-primary' : 'text-title'" class="text-12">
                    {{ $t('doesnt_need_room') }}
                  </span>
                </div>
              </label>
              <label class="cursor-pointer">
                <input
                  type="checkbox"
                  id="save_default"
                  class="check-box-classes hidden"
                  v-model="is_private"
                />
                <div
                  class="flex items-center justify-center gap-x-10 h-50"
                  :class="is_private ? 'bg-primaryOpacity font-bold' : ''"
                >
                  <eye-slash-icon
                    :color="is_private ? 'var(--color-primary)' : 'var(--color-icon)'"
                  />
                  <span :class="is_private ? 'text-primary' : 'text-title'" class="text-12">
                    {{ $t('confidential_meeting') }}
                  </span>
                </div>
              </label>
            </div>
            <div class="border border-default mt-20 rounded-sm" v-outside="closePopoverHandler">
              <div @click="popoverToggle('start')" class="setting-section">
                <span>{{ $t('start') }}</span>
                <div class="text-14 flex items-center">
                  <div dir="ltr">
                    <span :class="dateDirection" class="text-subtitle">
                      {{ newStartDate }}
                    </span>
                    <span class="text-14 text-subtitle text-center">
                      {{ startHours }}:{{ startMinutes }}
                    </span>
                  </div>
                  <down-arrow class="down-arrow" />
                </div>
              </div>
              <div
                v-if="this.openTab === 'start'"
                class="rounded-t-none absolute z-50 w-full bg-secondary
                 shadow-md rounded border border-default"
              >
                <div class="overflow-auto">
                  <date-picker
                  format="YYYY-MM-DD"
                  :locale-config="{
                    fa: {
                      displayFormat: 'jDD jMMMM jYYYY',
                      lang: { label: 'شمسی' },
                    },
                    en: {
                      displayFormat: 'DD MMMM YYYY',
                      lang: { label: 'Gregorian' },
                    },
                  }"
                  :locale="calendar === 'Solar' ? 'fa' : 'en'"
                  v-model="startDate"
                  inline
                  @change="startCalendarChangeDateHandler"
                  custom-input=".calendar-hidden-input"
                  :highlight="highlight"
                />
                </div>
                <span class="px-16 text-title text-18 font-medium">{{ $t('time') }}</span>
                <div class="time-picker-group">
                  <scroll-picker
                    :options="startHourOptions"
                    :class="{ 'last-days': isDaysBefore }"
                    v-model="startHours"
                  />
                  <span class="clock-separator" :class="{ 'last-days': isDaysBefore }">:</span>
                  <scroll-picker
                    :options="startMinuteOptions"
                    :class="{ 'last-days': isDaysBefore }"
                    v-model="startMinutes"
                  />
                </div>
                <div class="flex gap-x-10 p-10">
                  <base-button
                    height="48"
                    width="167"
                    @click.native="openTab = ''"
                    buttonType="cancel"
                    radius="default"
                  >
                    <template #text>
                      <span class="text-14 font-bold">
                        {{ $t('cancel') }}
                      </span>
                    </template>
                  </base-button>
                  <base-button
                    height="48"
                    width="167"
                    @click.native="openTab = ''"
                    buttonType="primary"
                    radius="default"
                  >
                    <template #text>
                      <span class="text-14 font-bold"> {{ $t('set') }} {{ $t('start') }} </span>
                    </template>
                  </base-button>
                </div>
              </div>
              <div @click="popoverToggle('end')" class="setting-section">
                <span>{{ $t('end') }}</span>
                <div class="text-14 flex items-center">
                  <div dir="ltr">
                    <span :class="dateDirection" class="text-subtitle">
                      {{ newEndDate }}
                    </span>
                    <span class="text-14 text-subtitle text-center">
                      {{ endHours }}:{{ endMinutes }}
                    </span>
                  </div>
                  <down-arrow class="down-arrow" />
                </div>
              </div>
              <div
                v-if="this.openTab === 'end'"
                class="rounded-t-none absolute z-50 w-full bg-secondary
                 shadow-md rounded border border-default"
              >
                <div class="overflow-auto">
                  <date-picker
                  format="YYYY-MM-DD"
                  :locale-config="{
                    fa: {
                      displayFormat: 'jDD jMMMM jYYYY',
                      lang: { label: 'شمسی' },
                    },
                    en: {
                      displayFormat: 'DD MMMM YYYY',
                      lang: { label: 'Gregorian' },
                    },
                  }"
                  :locale="calendar === 'Solar' ? 'fa' : 'en'"
                  v-model="endDate"
                  inline
                  @change="endCalendarChangeDateHandler"
                  custom-input=".calendar-hidden-input"
                  :highlight="endHighlight"
                />
                </div>
                <div class="flex items-center px-16">
                  <span class="text-18 text-title font-medium">{{ $t('time') }}</span>
                  <span class="text-sm text-subtitle px-5 dir-ltr">
                    {{ durationTime }}
                  </span>
                </div>
                <div class="time-picker-group">
                  <scroll-picker
                    :options="endHourOptions"
                    :class="{ 'last-days': isDaysBefore }"
                    v-model="endHours"
                  />
                  <span class="clock-separator" :class="{ 'last-days': isDaysBefore }">:</span>
                  <scroll-picker
                    :options="endMinuteOptions"
                    :class="{ 'last-days': isDaysBefore }"
                    v-model="endMinutes"
                  />
                </div>
                <div class="flex gap-x-10 p-10">
                  <base-button
                    height="48"
                    width="167"
                    @click.native="openTab = ''"
                    buttonType="cancel"
                    radius="default"
                  >
                    <template #text>
                      <span class="text-14 font-bold">
                        {{ $t('cancel') }}
                      </span>
                    </template>
                  </base-button>
                  <base-button
                    height="48"
                    width="167"
                    @click.native="openTab = ''"
                    buttonType="primary"
                    radius="default"
                  >
                    <template #text>
                      <span class="text-14 font-bold"> {{ $t('set') }} {{ $t('end') }} </span>
                    </template>
                  </base-button>
                </div>
              </div>
              <div @click="popoverToggle('repeat')" class="repetitive-section">
                <div class="flex justify-between items-center h-full">
                  <span>{{ $t('repeat') }}</span>
                  <div class="text-14 flex items-center">
                    <span class="text-14 text-subtitle text-center">
                      {{ repeatTime }}
                    </span>
                    <down-arrow class="down-arrow" />
                  </div>
                </div>
                <div v-if="isCustom" class="flex mt-15 flex-wrap max-w-full">
                  <p class="text-subtitle text-14 break-words">
                    {{ customRepeatOptionMessage }}
                  </p>
                </div>
              </div>
              <div
                v-if="openTab === 'repeat'"
                class="z-50 absolute w-full border border-default bg-secondary rounded"
              >
                <div class="flex flex-col">
                  <p
                    class="repetitive-option text-14 break-words"
                    @click="repeatCustomTimeHandler($t('custom'))"
                    v-if="isCustom"
                  >
                    {{ customRepeatOptionMessage }}
                  </p>
                  <p class="repetitive-option" @click="repeatTimeHandler($t('daily'))">
                    {{ $t('daily') }}
                  </p>
                  <p class="repetitive-option" @click="repeatTimeHandler(weeklyRepetitiveOption)">
                    {{ weeklyRepetitiveOption }}
                  </p>
                  <!-- <p
                    class="repetitive-option"
                    @click="repeatTimeHandler($t('monthly'))"
                  >
                    {{ $t('monthly') }}
                  </p> -->
                  <p class="repetitive-option" @click="repeatTimeHandler($t('does_not_repeat'))">
                    {{ $t('does_not_repeat') }}
                  </p>
                  <p class="repetitive-option" @click="repeatTimeHandler($t('custom'))">
                    {{ $t('custom') }}
                  </p>
                </div>
              </div>
            </div>
            <div class="attendees" @click="openAttendeesModalHandler()"
              v-if="reserveMeetingCompany.id && changeEvents">
              <span class="reserve-time-heading">
                {{ $t('attendees') }}
              </span>
              <div
                v-if="attendeesArray.length + guests.length"
                class="flex items-center text-subtitle"
              >
                <span>{{ selectedMembersCount + guests.length }}</span>
                <down-arrow class="down-arrow" />
              </div>
              <div v-else class="flex items-center">
                <p>{{ $t('none') }}</p>
                <down-arrow class="down-arrow" />
              </div>
            </div>
            <div>
              <base-skeleton v-if="isLoading" name="dataLoaderSkeleton" width="full" height="48" />
              <base-button
                v-else
                height="48"
                width="full"
                @click.native="submitMeeting"
                buttonType="primary"
                data-cy="reserve-meeting-btn"
                radius="default"
                :disabled="isButtonPermissionDisabled"
              >
                <template #icon v-if="loadingButton && reserveIsLoading">
                  <div class="w-18 h-18">
                    <base-loading size="full" borderWidth="2" spinnerColor="primary" />
                  </div>
                </template>
                <template #text v-else>
                  <span class="text-18">{{ $t('create_meeting') }}</span>
                </template>
              </base-button>
            </div>
          </div>
        </div>
        <!-- End Calendar -->
        <!-- Start Event -->
        <div class="w-full full-width duration calendar-width">
          <div :class="{ 'opacity-0': !showCalendarHint }" class="duration-300">
            <div class="flex items-center justify-end px-16 gap-x-3">
              <InfoAlert />
              <p class="text-subtitle">
                {{
                  $t('calendar_alert', {
                    calendar:
                      reserveMeetingDevice.name && !need_room
                        ? reserveMeetingDevice.name
                        : $t('my_calendar'),
                  })
                }}
              </p>
            </div>
          </div>
          <div>
            <div class="time-line-bordered mt-10">
              <div v-if="isLoading">
                <div
                  v-for="index in 6"
                  :key="`key-${index}`"
                  class="flex flex-row-reverse items-center gap-x-2 mb-10"
                >
                  <base-skeleton
                    name="dataLoaderSkeleton"
                    class="calendar-width w-full full-width"
                    width="full"
                    height="128"
                  />
                  <base-skeleton name="dataLoaderSkeleton" rounded="full" width="20" height="20" />
                </div>
              </div>

              <full-event-calender
                v-else
                :dateToStart="new Date(startDate)"
                :isPinchActive="false"
                :oneHourInPixel="80"
                markOverLappingBorders
                type="day"
                :locale="$i18n.locale === 'fa' ? 'fa-IR' : 'en-US'"
                :rtl="$i18n.locale === 'fa' || $i18n.locale === 'ar'"
                :eventList="computedReservationsList"
                :calendar="calendar === 'Solar' ? 'persian' : 'gregory'"
                :theme="theme"
                hideHeader
              >
              </full-event-calender>
            </div>
          </div>
        </div>
        <!-- End Event -->
      </div>
    </div>
    <TimelineConflictModal @reserveAnyway="reserveAnywayHandler" :calendar="calendar" />
    <!-- End TimeLine Bar -->
    <repetitive-meeting-modal
      :startDate="startDate"
      :calendar="calendar"
      :meetingInfo="meetingInfo"
      @daily="dailyHandler"
      @weekly="weeklyHandler"
      @repeat="repeatHandler"
      @closeRepetitiveMeeting="closeRepetitiveMeetingHandler"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import axiosConfig from '@/services/axios.config';
import { OnImageError } from '@/utils/on-image-error';
import BaseButton from '@/components/base/BaseButton.vue';
import TimelineConflictModal from '@/components/modals/TimelineConflictModal.vue';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import BaseSkeleton from '@/components/base/BaseSkeleton.vue';
import BaseLoading from '@/components/base/BaseLoading.vue';
import { ScrollPicker } from 'vue-scroll-picker';
import DownArrow from '@/assets/icons/vue/downArrow.vue';
import convertToBinary from '@/utils/boolean-converter';
import outside from '@/directives/clickOutSide';
import repetitiveMeetingModal from '@/views/conference/repetitiveMeetingModal.vue';
import i18n from '@/utils/i18n/i18n';
import customRepeatMessage from '@/views/conference/CustomRepeatMessage';
import imageResizer from '@/utils/image-resizer';
import InfoAlert from '@/assets/icons/vue/InfoAlert.vue';
import BaseMultiChoice from '@/components/base/BaseMultiChoice.vue';
import getUser from '@/services/profile/user.service';
import Room from '@/assets/icons/vue/Room.vue';
import AddAttendeeModal from '@/views/conference/modals/AddAttendeeModal.vue';
import EyeSlashIcon from '../../assets/icons/vue/eye-slash.vue';

const moment = require('moment-jalaali');

export default {
  name: 'DuplicateMeeting',
  components: {
    datePicker: VuePersianDatetimePicker,
    AddAttendeeModal,
    BaseSkeleton,
    BaseButton,
    BaseLoading,
    ScrollPicker,
    DownArrow,
    repetitiveMeetingModal,
    TimelineConflictModal,
    InfoAlert,
    BaseMultiChoice,
    Room,
    EyeSlashIcon,
  },
  directives: {
    outside,
  },
  data() {
    return {
      isBtnDisabled: true,
      guests: [],
      deviceId: this.$route.params.deviceId || this.meetingInfo.device_id,
      meetingId: '',
      today: new Date(),
      todayDate: moment(this.today).format('YYYY-MM-DD'),
      OnImageError,
      reserveMeeting: {
        started_at: '',
        meeting_name: '',
        meeting_time: null,
        attendees_user_id: [],
        meeting_description: '',
        device_id: '',
      },
      allMembers: [],
      attendeesArray: [],
      reserveIsLoading: false,
      imgError: false,
      reservations: [],
      deviceData: {},
      reserveId: this.$route.params.reserveId,
      startDate: this.meetingInfo.started_at.slice(0, 10),
      endDate: this.meetingInfo.ended_at.slice(0, 10),
      openTab: '',
      startHours: null,
      startMinutes: null,
      endHours: null,
      endMinutes: null,
      newStartDate: '',
      newEndDate: '',
      reserveAnyway: false,
      isMoreThanCapacity: false,
      repeatTime: this.$i18n.t('does_not_repeat'),
      isMeetingRepetitive: this.meetingInfo.is_repetitive,
      isCustom: false,
      repeat: null,
      imageSize: 150,
      showCalendarHint: false,
      reserveMeetingCompany: '',
      reserveMeetingDevice: {},
      need_room: false,
      is_private: this.meetingInfo.is_private,
      deviceOptions: [],
      isMediumScreen: false,
      defaultDevice: {},
      defaultCompany: {},
      companyModel: {},
      previousRepeatTime: '',
      renderAddAttendeeModal: false,
      initialMembers: [],
      initialGuests: [],
    };
  },
  props: {
    meetingInfo: {
      type: Object,
    },
    calendar: {
      type: String,
    },
  },
  computed: {
    weeklyRepetitiveOption() {
      let weekDay;
      if (this.calendar === 'Solar') {
        moment.locale('fa');
        weekDay = moment(this.startDate).format('dddd');
      } else {
        moment.locale('en');
        weekDay = moment(this.startDate).format('dddd');
      }
      return `${i18n.t('weekly')} ${i18n.t('on_day')} ${weekDay}`;
    },
    previewEvent() {
      return {
        started_at: `${this.startDate} ${this.startHours}:${this.startMinutes}`,
        ended_at: `${this.endDate} ${this.endHours}:${this.endMinutes}`,
        meeting_name: this.reserveMeeting.meeting_name,
        classList: [' preview-bix-bg'],
        notInjectBackGroundColors: true,
        hideIsGoing: true,
      };
    },
    changeEvents() {
      return !this.deviceId || this.need_room ? this.extractMeeting : this.reservations;
    },
    computedReservationsList() {
      const arr = [...this.changeEvents];
      arr.forEach((event) => {
        if (event.status !== 'approve' && event.status) {
          // eslint-disable-next-line no-param-reassign
          event.notInjectBackGroundColors = true;
          // eslint-disable-next-line no-param-reassign
          event.hideIsGoing = true;
          // eslint-disable-next-line no-param-reassign
          event.classList = [' event-border'];
          if (event.status === 'pending') {
            // eslint-disable-next-line no-param-reassign
            event.badgeClassList = [' warning-badge'];
            // eslint-disable-next-line no-param-reassign
            event.badge = i18n.t('awaiting_confirmation');
          } else {
            // eslint-disable-next-line no-param-reassign
            event.badgeClassList = [' danger-badge'];
            // eslint-disable-next-line no-param-reassign
            event.badge = i18n.t('rejected');
          }
        }
      });
      if (this.previewEvent) {
        arr.push(this.previewEvent);
      }
      return arr;
    },
    customRepeatOptionMessage() {
      if (!this.repeat) {
        return customRepeatMessage(
          this.meetingInfo.repetitive_meta.repeat_every,
          this.startHours,
          this.startMinutes,
          this.meetingInfo.repetitive_meta.type,
          this.meetingInfo.repetitive_meta.repeat_on_days,
          this.meetingInfo.repetitive_meta.end_on,
          this.meetingInfo.repetitive_meta.end_type,
          this.meetingInfo.repetitive_meta.end_after,
          this.calendar,
        );
        // eslint-disable-next-line no-else-return
      } else {
        return customRepeatMessage(
          this.repeat.repeat_every,
          this.startHours,
          this.startMinutes,
          this.repeat.type,
          this.repeat.repeat_on_days,
          this.repeat.end_on,
          this.repeat.end_type,
          this.repeat.end_after,
          this.calendar,
        );
      }
    },
    meetingInfoAndCalendar() {
      return `${this.meetingInfo}-${this.calendar}`;
    },
    ...mapGetters({
      currentCompany: 'getDefaultCompany',
      currentPermission: 'permissions/getPermissions',
      userInformation: 'getUserInformation',
      isLoading: 'loading/getActiveSkeletons',
      theme: 'getTheme',
      conflictInfo: 'reserve/getConflict',
      activeModal: 'modal/getActiveModal',
    }),
    durationTime() {
      const START_TIME = moment({
        hour: this.startHours,
        minute: this.startMinutes,
      });
      const END_TIME = moment({
        hour: this.endHours,
        minute: this.endMinutes,
      });
      const DIFF_HOUR = moment.duration(END_TIME.diff(START_TIME)).hours();
      const DIFF_MIN = moment.duration(END_TIME.diff(START_TIME)).minutes();
      if (this.startDate === this.endDate && DIFF_HOUR >= 0 && DIFF_MIN >= 0) {
        return `(${moment.duration(END_TIME.diff(START_TIME)).hours()} :
           ${moment.duration(END_TIME.diff(START_TIME)).minutes()})`;
      }
      return '';
    },
    loadingButton() {
      return this.$store.state.loading.loadingButton;
    },
    isButtonPermissionDisabled() {
      if (!this.meetingInfo.can_copy_meeting) {
        return true;
      }
      if (this.reserveMeetingDevice.name === undefined && this.need_room === false) {
        return true;
      }
      return false;
    },
    isDaysBefore() {
      const today = moment().endOf('day').format('YYYY-MM-DD');
      return moment(this.startDate).isBefore(moment(today));
    },
    startHourOptions() {
      return Array.from({ length: 24 }, (_, i) => this.zeroPadded(i));
    },
    startMinuteOptions() {
      // eslint-disable-next-line max-len
      const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => this.zeroPadded(start + i * step));
      return range(0, 55, 5);
    },
    endHourOptions() {
      return Array.from({ length: 24 }, (_, i) => this.zeroPadded(i));
    },
    endMinuteOptions() {
      // eslint-disable-next-line max-len
      const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => this.zeroPadded(start + i * step));
      return range(0, 55, 5);
    },
    isOwnerAndNone() {
      return this.$store.state.permissions.isOwner ? false : this.userRole === 'none';
    },
    dateDirection() {
      if (this.calendar === 'Solar' && this.$i18n.locale !== 'fa' && this.$i18n.locale !== 'ar') {
        return 'dir-rtl';
      }
      if (
        this.calendar === 'Gregorian'
        && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')
      ) {
        return 'dir-ltr';
      }
      if (this.calendar === 'Solar' && (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar')) {
        return 'dir-rtl';
      }
      return 'dir-ltr';
    },
    selectedMembersCount() {
      return this.attendeesArray.length;
    },
    extractMeeting() {
      let arr = [];
      this.conflictInfo.forEach((meeting) => {
        arr = arr.concat(meeting.meetings);
      });
      return arr;
    },
  },
  watch: {
    reserveMeeting: {
      handler() {
        this.$nextTick(() => {
          this.$refs.textarea.style.height = 'auto';
          const minHeight = 50;
          const newHeight = Math.max(minHeight, this.$refs.textarea.scrollHeight);
          this.$refs.textarea.style.height = `${newHeight}px`;
        });
      },
      deep: true,
    },
    need_room() {
      this.showCalendarHint = true;
      setTimeout(() => {
        this.showCalendarHint = false;
      }, 3000);
    },
    meetingInfoAndCalendar() {
      this.initiateDate();
    },
    attendeesArray() {
      this.checkCapacity(this.attendeesArray.length + this.guests.length);
    },
    guests() {
      this.checkCapacity(this.attendeesArray.length + this.guests.length);
    },
    repeatTime(newVal, oldVal) {
      this.previousRepeatTime = oldVal;
    },
  },
  mounted() {
    this.getDevices(this.meetingInfo);
    this.initiateDate();
    this.getDeviceReservations();
    this.editMeetingHandler();
    this.getUserReservationsHandler();
    if (this.meetingInfo.is_repetitive) {
      this.checkIsCustom();
    }
    this.checkDeviceType();
    window.addEventListener('resize', this.checkDeviceType);
  },
  methods: {
    setAllMembers(members) {
      this.allMembers = members;
    },
    setAttendeesArray(attendeesArray) {
      this.attendeesArray = attendeesArray;
    },
    setGuests(guests) {
      this.guests = guests;
    },
    repeatHandler(data) {
      this.repeat = data;
      this.isCustom = true;
    },
    checkIsCustom() {
      if (
        this.meetingInfo.repetitive_meta.type
        && this.meetingInfo.repetitive_meta.type === ('daily' || 'weekly')
        && (this.meetingInfo.repetitive_meta.repeat_every === 1
          || this.meetingInfo.repetitive_meta.repeat_every === '1')
        && this.meetingInfo.repetitive_meta.end_type === 'never'
      ) {
        this.isCustom = false;
      } else if (this.meetingInfo.repetitive_meta.type) {
        this.isCustom = true;
        this.repeatTime = this.$i18n.t('custom');
      }
    },
    getUserReservationsHandler() {
      axiosConfig
        .get(`/user/my-calendar?current_date=${this.startDate}`)
        .then((response) => {
          this.$store.commit('reserve/SET_CONFLICT', response.data.data);
        })
        .catch((error) => {
          serverErrorsHandler(error);
          throw error;
        });
    },
    getDevices(data) {
      const COMPANY = this.userInformation.companies.find(
        (company) => company.id === data.company_id,
      );
      this.defaultCompany = COMPANY;
      this.reserveMeetingCompany = COMPANY;
      axiosConfig
        .get(`/companies/${data.company_id}/devices?only_conference=1`)
        .then((response) => {
          this.deviceOptions = response.data.data;
          if (!this.deviceId) {
            this.defaultDevice = {};
            this.reserveMeetingDevice = {};
            this.need_room = true;
          } else {
            const DEVICE = this.deviceOptions.find((device) => device.id === +this.deviceId);
            this.reserveMeetingDevice = DEVICE;
            this.defaultDevice = DEVICE;
          }
          this.checkCapacity(this.attendeesArray.length + this.guests.length);
          this.renderAddAttendeeModal = false;
          this.$nextTick(() => {
            this.renderAddAttendeeModal = true;
          });
        })
        .catch((error) => {
          serverErrorsHandler(error);
        });
    },
    checkDeviceType() {
      this.isMediumScreen = window.innerWidth < 1024;
    },
    selectCompanyHandler(selectedCompany) {
      this.defaultCompany = selectedCompany;
      axiosConfig
        .get(`/companies/${selectedCompany.id}/devices?only_conference=1`)
        .then((response) => {
          this.deviceOptions = response.data.data;
          this.defaultDevice = {};
          this.reserveMeetingDevice = {};
          if (this.need_room) {
            this.need_room = true;
          } else {
            this.need_room = false;
          }
        })
        .catch((error) => {
          serverErrorsHandler(error);
        });
        this.reserveMeetingCompany = selectedCompany;
        this.companyModel = this.userInformation.companies.find(
          (company) => company.id === selectedCompany.id,
          );
        this.renderAddAttendeeModal = false;
        this.$nextTick(() => {
          this.renderAddAttendeeModal = true;
        });
    },
    selectDeviceHandler(selectedDevice) {
      this.showCalendarHint = true;
      setTimeout(() => {
        this.showCalendarHint = false;
      }, 3000);
      this.reserveMeetingDevice = selectedDevice;
      this.deviceId = selectedDevice.id;
      this.getUserReservationsHandler();
      this.getDeviceReservations();
      this.checkCapacity(this.attendeesArray.length + this.guests.length);
    },
    resizer(image) {
      return imageResizer(image, this.imageSize);
    },
    weeklyHandler() {
      this.repeatTime = this.weeklyRepetitiveOption;
      this.isCustom = false;
    },
    dailyHandler() {
      this.repeatTime = i18n.t('daily');
      this.isCustom = false;
    },
    closeRepetitiveMeetingHandler() {
      this.repeatTime = this.previousRepeatTime;
      if (this.previousRepeatTime === i18n.t('custom')) {
        this.isCustom = true;
      } else {
        this.isCustom = false;
      }
    },
    repeatCustomTimeHandler(data) {
      this.isCustom = true;
      this.repeatTime = data;
      this.openTab = '';
    },
    repeatTimeHandler(data) {
      this.isCustom = false;
      this.repeatTime = data;
      this.openTab = '';
      if (data === i18n.t('daily')) {
        this.repeat = {
          type: 'daily',
          repeat_every: 1,
          repeat_on_days: [],
          end_type: 'never',
          end_on: this.startDate,
          end_after: null,
          is_changed: false,
        };
      } else if (data === i18n.t('custom')) {
        this.$store.dispatch('modal/open', 'repetitiveMeeting');
        this.isCustom = true;
      } else if (data.includes(i18n.t('weekly'))) {
        this.repeat = {
          type: 'weekly',
          repeat_every: 1,
          repeat_on_days: [moment(this.startDate).locale('en').format('dddd').toLowerCase()],
          end_type: 'never',
          end_on: this.startDate,
          end_after: null,
          is_changed: false,
        };
      }
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    checkCapacity(capacity) {
      if (capacity > this.reserveMeetingDevice.capacity && this.reserveMeetingDevice.capacity) {
        this.isMoreThanCapacity = true;
      } else {
        this.isMoreThanCapacity = false;
      }
    },
    initiateDate() {
      // this.selectedDate = new Date(this.meetingInfo.started_at);
      if (this.calendar === 'Solar') {
        this.newStartDate = moment(this.meetingInfo.started_at.slice(0, 10)).format(
          'jYYYY-jMM-jDD',
        );
        this.newEndDate = moment(this.meetingInfo.ended_at.slice(0, 10)).format('jYYYY-jMM-jDD');
      } else {
        this.newStartDate = moment(this.meetingInfo.started_at.slice(0, 10)).format('YYYY-MM-DD');
        this.newEndDate = moment(this.meetingInfo.ended_at.slice(0, 10)).format('YYYY-MM-DD');
      }
    },
    closePopoverHandler() {
      if (this.openTab) {
        this.openTab = '';
      }
    },
    reserveAnywayHandler() {
      this.reserveAnyway = true;
      convertToBinary(this.reserveAnyway);
      this.duplicateMeeting();
      this.getUserReservationsHandler();
    },
    endHighlight(formatted) {
      const attributes = { title: `Today is ${this.startDate}` };
      if (moment(formatted).isBefore(moment(this.startDate))) {
        attributes.class = 'highlighted-disabled';
      }
      return attributes;
    },
    highlight(formatted) {
      const today = moment().endOf('day').format('YYYY-MM-DD');
      const attributes = { title: `Today is ${today}` };
      if (moment(formatted).isBefore(moment(today))) {
        attributes.class = 'highlighted-disabled';
      }
      return attributes;
    },
    startCalendarChangeDateHandler(event) {
      const newStartDate = this.calendar === 'Solar' ? event.format('jYYYY-jMM-jDD') : event.format('YYYY-MM-DD');
      this.newStartDate = newStartDate;
      this.endDate = this.startDate;
      this.newEndDate = this.newStartDate;
      this.getDeviceReservations();
    },
    endCalendarChangeDateHandler(event) {
      const newEndDate = this.calendar === 'Solar' ? event.format('jYYYY-jMM-jDD') : event.format('YYYY-MM-DD');
      this.newEndDate = newEndDate;
      // this.getDeviceReservations();
    },
    getDeviceReservations() {
      if (this.deviceId && !this.need_room) {
        this.$store.dispatch('loading/skeletonLoader', {
          name: 'dataLoaderSkeleton',
          status: true,
        });
        axiosConfig
          .get(
            `/companies/${this.defaultCompany.id}/devices/${this.deviceId}/reserves?current_date=${this.startDate}`,
          )
          .then((response) => {
            this.reservations = response.data.data;
            setTimeout(() => {
              this.$store.dispatch('loading/skeletonLoader', {
                name: 'dataLoaderSkeleton',
                status: false,
              });
            }, 0);
          })
          .catch((error) => {
            this.$store.dispatch('loading/skeletonLoader', {
              name: 'dataLoaderSkeleton',
              status: false,
            });
            serverErrorsHandler(error);
          });
      }
    },
    popoverToggle(data) {
      if (this.openTab === data) {
        this.openTab = '';
      } else {
        this.openTab = data;
      }
    },
    imageError($event) {
      this.imgError = true;
      this.OnImageError($event);
    },
    submitMeeting() {
      this.duplicateMeeting();
    },
    editMeetingHandler() {
      this.meetingId = this.meetingInfo.id;
      this.startHours = this.meetingInfo.started_at.slice(11, 13);
      this.startMinutes = this.meetingInfo.started_at.slice(14, 16);
      this.endHours = this.meetingInfo.ended_at.slice(11, 13);
      this.endMinutes = this.meetingInfo.ended_at.slice(14, 16);
      this.reserveMeeting.meeting_description = this.meetingInfo.meeting_description;
      if (this.meetingInfo.title === i18n.t('busy')) {
        this.reserveMeeting.meeting_name = '';
      } else {
        this.reserveMeeting.meeting_name = this.meetingInfo.title
          ? this.meetingInfo.title
          : this.meetingInfo.meeting_name;
      }
      // eslint-disable-next-line array-callback-return, consistent-return
      const filterAttendees = this.meetingInfo.attendees.filter((attendee) => {
        if (attendee.is_guest === false) {
          return attendee.id;
        }
      });
      this.initialMembers = filterAttendees.map(({ id }) => id);
      this.initialGuests = this.meetingInfo.attendees
      .filter((attendee) => attendee.is_guest === true);
      this.renderAddAttendeeModal = false;
      this.$nextTick(() => {
        this.renderAddAttendeeModal = true;
      });
    },
    removeEditHandler() {
      this.meetingId = '';
      this.reserveMeeting.meeting_name = '';
      this.getNextAvailableTime();
    },
    areObjectsEmpty(obj1, obj2) {
      return Object.keys(obj1).length === 0 && Object.keys(obj2).length === 0;
    },
    duplicateMeeting() {
      this.$store.commit('loading/LOADING_HANDLER', true);
      this.$store.commit('loading/DISABLE_HANDLER', true);
      this.reserveMeeting.started_at = `${this.startDate} ${this.startHours}:${this.startMinutes}:00`;
      this.reserveMeeting.ended_at = `${this.endDate} ${this.endHours}:${this.endMinutes}:00`;
      this.reserveMeeting.attendees_user_id = this.attendeesArray;
      this.reserveMeeting.guests = this.guests;
      this.reserveMeeting.is_private = convertToBinary(this.is_private);
      this.reserveMeeting.without_conflict = this.reserveAnyway;
      this.reserveMeeting.repeat = this.repeat;
      this.reserveMeeting.device_id = this.deviceId || '';
      if (!this.deviceId || this.need_room || this.areObjectsEmpty(this.reserveMeetingDevice, {})) {
        this.reserveMeetingDevice = {};
        this.reserveMeeting.device_id = '';
      } else {
        this.reserveMeeting.device_id = this.reserveMeetingDevice.id;
      }
      this.reserveMeeting.company_id = this.defaultCompany.id;
      if (this.repeatTime === i18n.t('does_not_repeat')) {
        this.reserveMeeting.is_repetitive = 0;
      } else {
        this.reserveMeeting.is_repetitive = 1;
      }
      axiosConfig
        .post('/companies/reserve-meeting', this.reserveMeeting)
        .then(() => {
          this.$store.commit('loading/LOADING_HANDLER', false);
          this.$store.commit('loading/DISABLE_HANDLER', false);
          this.getDeviceReservations();
          this.$toast.success(this.$t('updated'));
          if (this.defaultCompany.id !== this.currentCompany.id) {
            this.$store.dispatch('defaultCompany', this.companyModel);
            axiosConfig
              .post('/user/change-default-company', { company_id: this.defaultCompany.id })
              .then(async () => {
                localStorage.removeItem('user');
                await getUser();
              })
              .catch(() => {});
          }
          if (this.reserveMeetingDevice.id || !this.need_room) {
            this.$router.push({
              name: 'ConferenceRoom',
              params: { locale: this.$i18n.locale, id: this.reserveMeetingDevice.id },
              query: { date: `${this.startDate}` },
            });
          } else {
            this.$router
              .push({
                name: 'UserCalendar',
                params: { locale: this.$i18n.locale },
                query: { date: `${this.startDate}` },
              })
              .catch(() => {});
          }
        })
        .catch((error) => {
          const { response } = error;
          this.$store.commit('loading/LOADING_HANDLER', false);
          this.$store.commit('loading/DISABLE_HANDLER', false);
          // eslint-disable-next-line no-underscore-dangle
          delete this.reserveMeeting._method;
          if (error.response.status === 410) {
            this.$store.commit('reserve/SET_CONFLICT', response.data.data);
            this.$store.dispatch('modal/open', 'conflict');
          } else {
            serverErrorsHandler(error);
          }
          this.reserveAnyway = false;
        });
    },
    zeroPadded(num) {
      return num < 10 ? `0${num}` : num;
    },
    openAttendeesModalHandler() {
      this.$store.dispatch('modal/open', 'addAttendee');
    },
  },
};
</script>
<style scoped>
@media (max-width: 1024px) {
  .edit-meeting-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .full-width {
    width: 100%;
  }
}
@media (max-width: 1343px) and (min-width: 1025px) {
  .reserve-width {
    width: 40%;
  }
  .calendar-width {
    width: 60%;
  }
}
.back-icon {
  @apply w-50 h-50 rounded flex border-2 border-default left-50 cursor-pointer;
}
.meeting-description {
  @apply bg-secondary outline-none border border-t-0 border-b-0 pt-12
    border-default overflow-hidden resize-none w-full focus:ring-0 h-50;
}
.meeting-name {
  @apply bg-secondary outline-none border border-t-1 rounded-t-sm
    border-default overflow-hidden resize-none w-full focus:ring-0 h-50;
}
.message-bordered,
.time-line-bordered {
  @apply w-full rounded-sm;
}
.last-days {
  @apply opacity-80 bg-theme-secondary bg-none;
}
.down-arrow {
  @apply ml-5;
}
.down-arrow:is(:lang(fa), :lang(ar)) {
  @apply mr-5;
}
.dir-rtl {
  direction: rtl;
}
.dir-ltr {
  direction: ltr;
}
.setting-section {
  @apply py-5 px-10 flex justify-between items-center border-b border-default
   hover:bg-tertiary cursor-pointer hover:rounded-sm h-50;
}
.attendees {
  @apply border border-default my-20 rounded-sm py-5 px-10 flex justify-between
   hover:bg-tertiary cursor-pointer items-center h-50;
}
.repetitive-section {
  @apply border-b-0 border-default p-10 hover:bg-tertiary
   cursor-pointer hover:rounded-sm min-h-50;
}
.repetitive-option {
  @apply px-22 py-12 text-title hover:bg-tertiary rounded cursor-pointer;
}
</style>
<style>
.preview-bix-bg {
  @apply font-semibold;
  color: #ffa200;
  border: 2.7px dashed #ffa200;
  background-color: rgba(255, 162, 0, 0.1);
  font-size: 13px;
  backface-visibility: hidden !important;
  transition: all 0.2s ease !important;
}
.vpd-is-inline {
  @apply rounded-sm;
}
.vpd-header {
  @apply rounded-t-sm bg-theme-secondary !important;
}
.vpd-header {
  @apply bg-theme-secondary text-title;
}
.vpd-selected .vpd-day-text {
  @apply text-secondary;
}
.vpd-day-text {
  @apply text-blueText;
}
.vpd-content,
.vpd-container {
  @apply bg-theme-secondary rounded-sm;
}
.vpd-container {
  @apply border border-theme-primary;
}
.vpd-prev,
.vpd-next {
  @apply flex justify-center items-center;
}
.vpd-header {
  @apply pt-20;
}
.vpd-month-label {
  @apply w-110 !important;
}
.duration-item {
  @apply w-70 h-70 shadow-lg rounded-full flex justify-center items-center text-48
      text-title cursor-pointer my-15 mx-10 select-none lg:w-56 lg:h-56;
}
.duration-text {
  @apply text-18 flex-grow self-center text-center my-20 mx-10 select-none;
}
.time-picker-group,
.duration-group {
  @apply flex border rounded-sm border-default mx-15 mt-10;
  direction: ltr;
}
.duration-group {
  @apply mx-10 my-30;
}
.clock-separator {
  @apply text-36 self-center;
}
.end-time-container {
  @apply text-14 text-center flex justify-between items-center lg:my-10;
}
.end-time {
  direction: ltr;
}
</style>
<style lang="css">
/* .vpd-content {
  width: 100%;
} */
.vpd-container {
  border: none !important;
}
.highlighted-disabled > span {
  @apply text-subtitle;
}
.vue-scroll-picker-layer .top,
.vue-scroll-picker-layer .bottom {
  @apply rounded-sm border-none text-title opacity-80 bg-theme-secondary bg-none;
}
.vue-scroll-picker-item {
  @apply text-36 my-20;
}
.last-days .vue-scroll-picker-layer .middle {
  @apply opacity-80 bg-theme-secondary bg-none;
}
.vue-scroll-picker {
  height: 14rem;
}
</style>
